import { Form, Button, Spin, message } from 'antd/lib'
import { DefaultEditor } from 'react-simple-wysiwyg'
import { useForm } from 'antd/lib/form/Form'
import { useState, useEffect, ChangeEvent } from 'react'
import { Helmet } from 'react-helmet'
import { useHistory } from 'react-router-dom'
import DOMPurify from 'dompurify'
import { api, authApi } from '../../../api/api'
import { isLoading } from '../../../utils/functions'
import { REQUEST_STATUS } from '../../../utils/types'
import {
    CustomForm,
    CustomRow,
    EditorWrapper,
} from './AddTermsAndConditions.styles'
import { IAddTermsAndConditionsForm } from './AddTermsAndConditions.types'

const AddTermsAndConditions: React.FC = () => {
    const history = useHistory()
    const [form] = useForm()
    const [requestStatus, setRequestStatus] = useState<REQUEST_STATUS>(
        REQUEST_STATUS.NONE
    )
    const [editorValue, setEditorValue] = useState('')
    useEffect(() => {
        setRequestStatus(REQUEST_STATUS.PENDING)
        api.get('/api/setting/termConditions')
            .then((result: any) => {
                const content = DOMPurify.sanitize(result.data) || ''
                setEditorValue(content)
                form.setFieldsValue({ tCContent: content })
                setRequestStatus(REQUEST_STATUS.SUCCESS)
            })
            .catch(() => {
                setRequestStatus(REQUEST_STATUS.FAILED)
            })
    }, [form])
    const aToken = localStorage.getItem('aToken')
    const onSubmit = (formData: unknown): void => {
        setRequestStatus(REQUEST_STATUS.PENDING)
        const data = formData as IAddTermsAndConditionsForm
        authApi
            .post(
                `api/setting/termConditions/update`,
                { contentString: DOMPurify.sanitize(data.tCContent) },
                { headers: { Authorization: `Bearer ${aToken}` } }
            )
            .then((result: any) => {
                if (result?.data) {
                    setRequestStatus(REQUEST_STATUS.SUCCESS)
                    history.push({ pathname: '/projects' })
                    message.success('Term and Condition content updated.', 5)
                } else {
                    message.error('Failed, please try again.', 5)
                }
            })
            .catch((error: any) => {
                form.setFields([
                    {
                        name: 'tCContent',
                        errors: [error?.response?.data?.message],
                    },
                ])
                setRequestStatus(REQUEST_STATUS.FAILED)
            })
    }
    const onSubmitFailed = (): void => {
        setRequestStatus(REQUEST_STATUS.FAILED)
    }
    return (
        <CustomRow justify="center" align="middle">
            <Helmet title="Add Terms And Conditions" />
            <Spin spinning={isLoading(requestStatus)}>
                <CustomForm
                    labelCol={{
                        span: 24,
                    }}
                    wrapperCol={{
                        span: 24,
                    }}
                    layout="vertical"
                    requiredMark="optional"
                    onFinish={onSubmit}
                    onFinishFailed={onSubmitFailed}
                    form={form}
                >
                    <Form.Item
                        label="Add Terms & Conditions Content"
                        name="tCContent"
                    >
                        <EditorWrapper>
                            <DefaultEditor
                                value={editorValue}
                                onChange={(
                                    e: ChangeEvent<HTMLInputElement>
                                ) => {
                                    setEditorValue(e.target.value)
                                    form.setFieldsValue({
                                        tCContent: e.target.value,
                                    })
                                }}
                                placeholder="Enter Terms & Conditions Content"
                                style={{
                                    minHeight: '130px',
                                    maxHeight: '230px',
                                    overflowY: 'auto',
                                }}
                            />
                        </EditorWrapper>
                    </Form.Item>
                    <Form.Item wrapperCol={{ span: 2 }}>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </CustomForm>
            </Spin>
        </CustomRow>
    )
}

export default AddTermsAndConditions
